import { useSearchParams } from "react-router-dom";
import EmployeeFormScreen from "@/pages/employees/components/EmployeeFormScreen";

export default function EmployeeNewPage() {
  const [searchParams] = useSearchParams();
  const defaultBranchId = searchParams.get("branch") ?? "";

  return (
    <EmployeeFormScreen employee={null} defaultBranchId={defaultBranchId} />
  );
}